
import React, { PureComponent } from 'react';
import GlobalStyle from 'stylecomponents/globalstyle';
import Tile from 'components/commons/Tile';
import GLOBAL from 'nonnglobal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';

const Content = GlobalStyle.SubContainer.extend`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: ${GlobalStyle.ViewSpace}px;
`;
class ProfiteventView extends PureComponent {

  constructor(props) {
    super(props);

    this.fetchListProfitEvents = this.fetchListProfitEvents.bind(this);
  }

  componentDidMount() {
    window.scrollTo({ top: 0 });
    this.fetchListProfitEvents();
  }

  fetchListProfitEvents() {
    this.props.profitEventActions.listProfitEvents();
  }

  toProfitEvent = ({ eventid, clickurl } = {}) => {
    this.props.profitEventActions.logProfitEventClick({
        eventid,
    });
    window.location.assign(clickurl);
  }

  render() {

    const tileStyle = {
      tileHeight: 264,
      imgHeight: 180,
      fontSize: 16,
      type: 'profitEvent',
      noMarginBottom: true,
    };

    const {
        profitEventMap,
        profitEventIds = [],
        isloading,
        isEmpty,
    } = this.props;

    return (
      <GlobalStyle.SubContainer>
        <Content>
          {profitEventIds.map(eventId => {

            const profitEvent = profitEventMap[eventId];

            const {
                title = '',
                eventimg,
                clickurl,
            } = profitEvent;

            return (
              <Tile
                key={eventId}
                img={GLOBAL.imgSrcRootURL + `/profiteventimgs/${eventId}/${eventimg}`}
                text={title}
                id={eventId}
                detailState={'PROFITEVENT_CONTENT'}
                tileStyle={tileStyle}
                clickCallback={this.toProfitEvent}
                callbackParams={{ eventid: eventId, clickurl }}
              />
            );
          })}
        </Content>
        {isloading && this.renderLoading()}
        {isEmpty && !isloading && this.renderEmpty()}
      </GlobalStyle.SubContainer>

    )
  }

  renderLoading = () => (
    <GlobalStyle.LoadingContainer>
        <GlobalStyle.Spin />
    </GlobalStyle.LoadingContainer>
  )

  renderEmpty = () => (
    <GlobalStyle.BasicBlock>
        <GlobalStyle.ErrorContainer>
            <GlobalStyle.ErrorContainerTitle>沒有好康活動</GlobalStyle.ErrorContainerTitle>
            <GlobalStyle.ErrorContainerDesription>當前尚無任何好康活動</GlobalStyle.ErrorContainerDesription>
        </GlobalStyle.ErrorContainer>
    </GlobalStyle.BasicBlock>
  )

}
/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
      profitEventMap: state.profitevent.itemMap,
      profitEventIds: state.profitevent.ids,
      isloading: state.profitevent.isloading,
      isEmpty: state.profitevent.isEmpty,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
      profitEventActions: bindActionCreators(actionCreators.profitEventActionCreators, dispatch),
  };
};

/*--------------------------
  Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(ProfiteventView);